import React from "react";
import { Icons, Box, Typography } from "@curves/ui-base";

// ↓ ↑
// type : up | down
const MetricSummaryCard = ({ sourceData }) => {
	const { label, mainValue, diffValue, isIncrease = true } = sourceData;

	const mValueType = mainValue > 0 ? "↑" : mainValue < 0 ? "↓" : "";
	return (
		<Box
			style={{
				display: "flex",
				justifyContent: "space-between",
				backgroundColor: "rgba(255 255 255 / 1)",
				boxShadow: "0 0 #000,0 0 #000,0 1px 2px 0",
				padding: 21,
				borderWidth: 1,
				borderRadius: 10.5,
			}}
		>
			<Box>
				<Typography component="span" style={{ color: "rgba(100 116 139/1)", fontWeight: 500, fontSize: 12 }}>
					{label}
				</Typography>
				<Typography component="div" color="primary" variant="h3" style={{ fontWeight: 700, margin: "6px 0 6px 0" }}>
					{mainValue}
				</Typography>
				<Box style={{ fontSize: 10.5, color: isIncrease ? "rgb(5, 150, 105)" : "rgb(225 29 72)" }}>
					<Typography component="span" style={{ marginRight: 3.5, fontSize: 10.5 }}>
						{mValueType}
					</Typography>
					<Typography component="span" style={{ fontSize: 10.5 }}>
						{`${diffValue}%相較上月`}
					</Typography>
				</Box>
			</Box>
			<Box>
				<Icons.ActionAddUser />
			</Box>
		</Box>
	);
};

export default MetricSummaryCard;
